/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Public half of the analytics module — what the web client needs to boot its Matomo tracker before login. Absent when the module is off.
 * @export
 * @interface PortalAnalytics
 */
export interface PortalAnalytics {
    /**
     * Matomo server base URL, always with a trailing slash.
     * @type {string}
     * @memberof PortalAnalytics
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalAnalytics
     */
    site_id?: string;
    /**
     * Tracking endpoint path relative to the server URL (stock Matomo: 'matomo.php').
     * @type {string}
     * @memberof PortalAnalytics
     */
    tracker_path?: string;
    /**
     * Tracking JavaScript path relative to the server URL (stock Matomo: 'matomo.js').
     * @type {string}
     * @memberof PortalAnalytics
     */
    script_path?: string;
    /**
     * Domains to treat as first-party for cross-domain link tracking, derived from the tenant domain.
     * @type {Array<string>}
     * @memberof PortalAnalytics
     */
    domains?: Array<string>;
}

/**
 * Check if a given object implements the PortalAnalytics interface.
 */
export function instanceOfPortalAnalytics(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortalAnalyticsFromJSON(json: any): PortalAnalytics {
    return PortalAnalyticsFromJSONTyped(json, false);
}

export function PortalAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'site_id': !exists(json, 'site_id') ? undefined : json['site_id'],
        'tracker_path': !exists(json, 'tracker_path') ? undefined : json['tracker_path'],
        'script_path': !exists(json, 'script_path') ? undefined : json['script_path'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
    };
}

export function PortalAnalyticsToJSON(value?: PortalAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'site_id': value.site_id,
        'tracker_path': value.tracker_path,
        'script_path': value.script_path,
        'domains': value.domains,
    };
}

